import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from './authService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);       // logged-in user info
  const [loading, setLoading] = useState(true); // true while checking session
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Initialize: check if user is logged in
  useEffect(() => {
    const initAuth = async () => {
      try {
        const storedUser = localStorage.getItem("user");

        if (storedUser) {
          // Use stored user directly
          setUser(JSON.parse(storedUser));
          setIsAuthenticated(true);
        } else {
          // No stored user, call API to check session
          const res = await authService.getUserDetails();

          if (res?.user) {
            setUser(res.user);
            setIsAuthenticated(true);
            localStorage.setItem("user", JSON.stringify(res.user));
          } else {
            setUser(null);
            setIsAuthenticated(false);
          }
        }
      } catch (err) {
        setUser(null);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    initAuth();
  }, []);


  // Login function
  const login = async (email, password) => {
    const res = await authService.login(email, password);
    if (res.success && res.user) {
      localStorage.setItem("user", JSON.stringify(res.user));
      setUser(res.user);
      setIsAuthenticated(true);
    }
    return res;
  };

  // Logout function
  const logout = async () => {
    await authService.logout();
    localStorage.removeItem("user");
    setUser(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook
export const useAuth = () => useContext(AuthContext);
